// extracted by extract-css-chunks-webpack-plugin
module.exports = {"financeVideo":"financeVideo-RvMta8x6","trans":"trans-2ATey-r4","list":"list-g_d5m1YO"};